function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader!../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-538a5931\",\"scoped\":false,\"hasInlineConfig\":false}!autoprefixer-loader!sass-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./content.vue")
}
var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./content.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-538a5931\",\"hasScoped\":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./content.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/content.vue
// module id = 4
// module chunks = 0